module.exports = __webpack_public_path__ + "img/logo.d89d99c0.svg";